import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  clearPeople,
  fetchPeople,
  setPeopleParams,
} from '../../actions/People';

import { goalSortSetting } from '../../helpers/Sort';

const PeopleSort = ({ setOrder, orderBy, order }) => {
  const intl = useIntl();

  const goalSortSettingValue = goalSortSetting(orderBy, order);

  return (
    <UncontrolledDropdown>
      <DropdownToggle
        id="PeopleSort"
        className="transparent-button"
      >
        <i className="fal fa-arrow-down-arrow-up" />
      </DropdownToggle>
      <UncontrolledTooltip target="PeopleSort" fade={false} placement="top" boundariesElement="body">
        {intl.formatMessage({ defaultMessage: 'Sort' })}
        {goalSortSettingValue && (
          <>
            {': '}
            {goalSortSettingValue.label}
          </>
        )}
      </UncontrolledTooltip>
      <DropdownMenu>
        <DropdownItem
          active={orderBy === 'created_at' && order === 'desc'}
          onClick={() => {
            setOrder('created_at', 'desc');
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Newest' })}
        </DropdownItem>
        <DropdownItem
          active={orderBy === 'created_at' && order === 'asc'}
          onClick={() => {
            setOrder('created_at', 'asc');
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Oldest' })}
        </DropdownItem>
        <DropdownItem
          active={orderBy === 'faces' && order === 'desc'}
          onClick={() => {
            setOrder('faces', 'desc');
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Most identified' })}
        </DropdownItem>
        <DropdownItem
          active={orderBy === 'faces' && order === 'asc'}
          onClick={() => {
            setOrder('faces', 'asc');
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Least identified' })}
        </DropdownItem>
        <DropdownItem
          active={orderBy === 'name' && order === 'asc'}
          onClick={() => {
            setOrder('name', 'asc');
          }}
        >
          {intl.formatMessage({ defaultMessage: 'A-Z' })}
        </DropdownItem>
        <DropdownItem
          active={orderBy === 'name' && order === 'desc'}
          onClick={() => {
            setOrder('name', 'desc');
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Z-A' })}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const mapStateToProps = state => ({
  orderBy: state.People.params.orderBy,
  order: state.People.params.order,
});

const mapDispatchToProps = (dispatch) => ({
  setOrder: (orderBy, order) => {
    dispatch(clearPeople());
    dispatch(setPeopleParams({
      orderBy,
      order,
      page: 0,
    }));
    dispatch(fetchPeople());
  },
});

PeopleSort.propTypes = {
  setOrder: PropTypes.func.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleSort);
